<template>
  <div>

    <!-- 저장하기 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="saveData">저장하기</button>
    </div>

    <div class="columns is-multiline">
      <!-- 주문상품 -->
      <div class="column is-full">
        <div class="box">
          <admin-box-item title="주문상품">
            <div class="columns is-multiline">
              <div class="column is-full" v-if="value.order_product.length>0">
                <table class="table">
                  <thead>
                  <tr>
                    <td>이미지</td>
                    <td>상품명</td>
                    <td>수량</td>
                    <td>판매가</td>
                    <td>합계금액</td>
                    <td>배송비</td>
                    <td>삭제</td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(op,idx) in value.order_product" :key="'order_prod-'+idx">
                    <td><div style="text-align: center; display: inline-block;"
                             :style="imgField(op.img)"></div></td>
                    <td>{{ op.name }}</td>
                    <td><input class="input product-short-input"
                               :value="op.quantity"
                               @input="e=>setNumber(e, op, 'quantity', 3)"
                               type="number"></td>
                    <td>{{ op.total_price | currency }}</td>
                    <td v-if="idx===0" :rowspan="value.order_product.length">{{ order.total_price | currency }}</td>
                    <td v-if="op.rowspan>0" :rowspan="op.rowspan">
                      {{ calcDeliveryPrice(op, idx) | currency }}
                    </td>
                    <td><button class="button is-danger" @click="deleteOrderProduct(idx)">삭제</button></td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="column is-full">
                <div class="flex btn-group-justify-end">
                  <button class="button" @click="clickProduct">상품추가</button>
                </div>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>
      <!-- 주문자 정보 -->
      <div class="column is-6">
        <div class="box">
          <admin-box-item title="주문자 정보">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item label="회원구분">
                  <div class="flex">
                    <lp-radio :val.sync="is_user"
                              value_name="value"
                              label_name="label"
                              :data="is_user_arr"></lp-radio>
                    <button class="button" v-if="is_user" @click="$modal.show('userlistModal')">회원선택</button>
                  </div>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="주문자성함*">
                  <input class="input"
                         :value="value.order.name"
                         @input="e=>value.order.name=e.target.value"
                         type="text" maxlength="30">
                </admin-form-item>
              </div>
              <!--<div class="column is-full">
                <admin-form-item label="전화번호">
                  <input class="input"
                         :value="value.order.tphone"
                         @input="e=>value.order.tphone=e.target.value"
                         type="text" maxlength="30">
                </admin-form-item>
              </div>-->
              <div class="column is-full">
                <admin-form-item label="휴대전화번호*">
                  <input class="input"
                         :value="value.order.phone"
                         @input="e=>value.order.phone=e.target.value"
                         type="text" maxlength="30">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="이메일*">
                  <input class="input"
                         :value="value.order.email"
                         @input="e=>value.order.email=e.target.value"
                         type="text" maxlength="30">
                </admin-form-item>
              </div>
              <!--<div class="column is-full">
                <admin-form-item label="주소*">
                  <lp-address :data.sync="value.order.address"></lp-address>
                </admin-form-item>
              </div>-->
            </div>
          </admin-box-item>
        </div>
      </div>

      <!-- 받는 분 정보 -->
      <div class="column is-6">
        <div class="box">
          <admin-box-item title="수령자 정보">
            <div class="columns is-multiline">
              <div class="column is-full">
                <lp-check-bool :checkedVal.sync="isEqualUser"
                               label="주문자 정보와 상품 정보가 동일합니다."></lp-check-bool>
              </div>
              <div class="column is-full">
                <admin-form-item label="수령*">
                  <input class="input"
                         :value="this.delivery.name"
                         @input="e=>this.delivery.name=e.target.value"
                         type="text" maxlength="30">
                </admin-form-item>
              </div>
              <!--<div class="column is-full">
                <admin-form-item label="전화번호">
                  <input class="input"
                         :value="this.delivery.tphone"
                         @input="e=>this.delivery.tphone=e.target.value"
                         type="text" maxlength="30">
                </admin-form-item>
              </div>-->
              <div class="column is-full">
                <admin-form-item label="휴대전화번호*">
                  <input class="input"
                         :value="this.delivery.phone"
                         @input="e=>this.delivery.phone=e.target.value"
                         type="text" maxlength="30">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="배송지 주소*">
                  <lp-address :data.sync="this.delivery.address"></lp-address>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="배송 메">
                  <input class="input"
                         :value="this.delivery.memo"
                         @input="e=>this.delivery.memo=e.target.value"
                         type="text" maxlength="100">
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>
      <!-- 결제정보 -->
      <div class="column is-full">
        <div class="box">
          <admin-box-item title="결제정보">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item label="수수료 합계 금액">
                  {{ value.order.comm_price | currency }}
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="포인트 합계 금액">
                  {{ value.order.point | currency }}
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="할인 합계 금액">
                  {{ value.order.discount_price | currency }}
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="상품 합계 금액">
                  {{ value.order.product_price | currency }}
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="배송비">
                  {{ value.order.delivery_cost | currency }}
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="최종 결제 금액">
                  {{ value.order.total_price | currency }}
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>

      <!-- 결제수단 -->
      <div class="column is-full">
        <div class="box">
          <admin-box-item title="환불 받을 계좌">
            <div class="columns is-multiline">
              <div class="column is-2">
                <admin-form-item label="은행*">
                  <input class="input"
                         :value="value.order.refund_info.bank"
                         @input="e=> value.order.refund_info.bank = e.target.value">
                </admin-form-item>
              </div>
              <div class="column is-2">
                <admin-form-item label="이름*">
                  <input class="input"
                         :value="value.order.refund_info.name"
                         @input="e=> value.order.refund_info.name = e.target.value">
                </admin-form-item>
              </div>
              <div class="column is-2">
                <admin-form-item label="계좌번호*">
                  <input class="input"
                         :value="value.order.refund_info.account"
                         @input="e=> value.order.refund_info.account = e.target.value">
                </admin-form-item>
              </div>
              <!--<div class="column is-full">
                <admin-form-item label="입금계좌*">
                  <span class="select">
                    <select v-model="purchase.bank" @change="selectBank">
                      <option v-for="bank in banklist">{{ bank.label }}</option>
                    </select>
                  </span>
                </admin-form-item>
              </div>-->
            </div>
          </admin-box-item>
        </div>
      </div>

      <!-- 상품 목록 팝업 -->
      <modal name="productlistModal"
             :adaptive="true"
             :width="900"
             height="auto"
             class="modal-style">
        <lp-order-product-create
          @addProduct="addProduct"
          @closeModal="$modal.hide('productlistModal')"></lp-order-product-create>
      </modal>

      <!-- 회원 목록 팝업 -->
      <modal name="userlistModal"
             :adaptive="true"
             :width="900"
             height="auto"
             class="modal-style">
        <user-list page="purchase" @selectUser="selectUser"></user-list>

      </modal>
    </div>

    <!-- 저장하기 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="saveData">저장하기</button>
    </div>
  </div>
</template>

<script>
  import LpCheckBool from "../../../module/common/LpCheckBool";
  import LpAddress from "../../../module/common/LpAddress";
  import LpRadio from "../../../module/common/LpRadio";
  import UserList from "../../user/UserList";
  import Const from "../../../../utils/const"
  import LpOrderProductCreate from "../../../module/custom/LpOrderProductCreate";

  export default {
    name: 'order-create',
    components: {
      LpOrderProductCreate,
      UserList,
      LpRadio,
      LpAddress,
      LpCheckBool},
    data() {
      return {
        value: {
          // 주문
          order: {
            user_id: '',
            name: '',
            tphone: '',
            phone: '',
            email: '',
            refund_info: {
              name: '',
              account: '',
              bank: ''
            },
            total_price: 0,
            discount_price: 0,
            delivery_price: 0,
            pay_type: 2,  // 무통장 입금
            deposit_name: '',
            bank: '',
            point: 0
          },
          // 주문 상품
          order_product: [],
          // 배송지
          delivery: {
            name: '',
            tphone: '',
            phone: '',
            address:{
              sido: '',
              sigungu: '',
              dong: '',
              detail: '',
              post_code: '',
              old: '',
              new: ''
            },
            memo: ''
          },
        },
        // 주문자 정보와 동일
        isEqualUser: false,
        is_user: false,
        is_user_arr: [
          { label: '비회원', value: false },
          { label: '회원', value: true }
        ],
        // 은행 계좌 목록
        banklist: [],
        products: []
      }
    },
    watch: {
      isEqualUser(n){
        if(n) this.equalUser();
        else this.initDelivery();
      }
    },
    created() {},
    methods: {
      // const.js 에 저장된 타입값을 가져옴
      convertType(property, status){
        return Const[property][status]
      },
      // 배송지 정보 초기화
      initDelivery(){
        this.value.delivery = {
          name: "",
          tphone: "",
          phone: "",
          address: {
            sido: "",
            sigungu: "",
            dong: "",
            detail: "",
            post_code: "",
            old: "",
            new: "",
            latitude: "",
            longitude: ""
          },
          memo: ""
        }
      },
      // 주문자와 동일
      equalUser(){
        this.value.delivery.name = this.value.order.name;
        this.value.delivery.tphone = this.value.order.tphone;
        this.value.delivery.phone = this.value.order.phone;
        this.value.delivery.email = this.value.order.email;
        // this.value.delivery.address = this.value.order.address;
      },
      deleteOrderProduct(index){
        removeIndex(this.value.order_product,index);
        this.initialize();
      },
      addProduct(value){
        this.value.order_product = this.value.order_product.concat(value);
        this.initialize();
        this.$modal.hide('productlistModal');
      },
      // 무통장 목록
      getNoPass(){
        this.$axios.get('public/commerce/bank').then(res=>{
          if(res.status === 200) {
            this.banklist = res.data;
          }
        })
      },
      // 입금계좌 선택
      selectBank(e){
        console.log(e)
        this.value.order.bank = e.target.value;
        ///
      },
      clickProduct(){
        this.$modal.show('productlistModal');
      },
      imgField(img) {
        return 'background-image: url('+this.image(img)+');' +
          ' width: 60px; height: 60px; background-size: cover;' +
          ' background-position: center;';
      },
      setNumber(e, order, type, max_length){
        if (type === 'quantity') {
          if( e.target.value.length > max_length ){
            order.quantity = e.target.value.substr(0,max_length);
          }
          else {
            order.quantity = e.target.value;
          }
        }
        this.initialize();
      },
      // 유저 선택
      selectUser(value){
        this.value.order.user_id = value.id;
        this.value.order.name = value.name;
        this.value.order.tphone = value.phone;
        this.value.order.phone = value.phone;
        this.value.order.email = value.email;
        // let address = {
        //   sido: "",
        //   sigungu: "",
        //   dong: "",
        //   detail: "",
        //   post_code: "",
        //   old: "",
        //   new: "",
        //   latitude: "",
        //   longitude: ""
        // }
        // if(value.address) address = value.address
        // this.value.order.address = address;
        this.$modal.hide('userlistModal');
      },
      // 수기주문 등록
      saveData(){
        let result = this.validCheck();
        if(result===false) return;
        this.$axios.post(this.getUrl('delivery/order'),{
          order: this.value.order,
          order_product: this.value.order_product,
          delivery: this.value.delivery
        }).then(res=>{
          if(res.status === 200) {
            this.toast('주문이 등록되었습니다.');
            this.$router.replace(this.getPath('delivery/order_list_order'));
          }
        })
      },
      // 필수입력값 체크
      validCheck(){
        let err = '';
        if(!this.value.order.name) err = '주문자명을 입력하세요.';
        else if(!this.value.order.tphone) err = '주문자 휴대전화번호를 입력하세요.';
        else if(!this.value.order.phone) err = '주문자 전화번호를 입력하세요.';
        else if(!this.value.order.email) err = '주문자 이메일을 입력하세요.';
        /*else if(!this.value.order.address.sido) err = '주문자 주소를 입력하세요.';
        else if(!this.value.order.address.detail) err = '주문자 상세 주소를 입력하세요.';*/
        else if(!this.value.delivery.name) err = '수령자명을 입력하세요.';
        else if(!this.value.delivery.tphone) err = '수령자 휴대전화번호를 입력하세요.';
        else if(!this.value.delivery.phone) err = '수령자 전화번호를 입력하세요.';
        else if(!this.value.delivery.address.sido) err = '수령자 주소를 입력하세요.';
        else if(!this.value.delivery.address.detail) err = '수령자 상세주소를 입력하세요.';
        else if(!this.value.order.refund_info.name) err = '환불받을 시 이름을 입력하세요.';
        else if(!this.value.order.refund_info.account) err = '환불받을 시 계좌를 입력하세요.';
        else if(!this.value.order.refund_info.bank) err = '환불받을 시 은행을 입력하세요.';
        /*else if(!this.value.order.deposit_name) err = '입금자명을 입력하세요.';
        else if(!this.value.order.bank) err = '입금계좌를 입력하세요.';*/

        else if(this.value.order_product.length===0) {
          err = '상품을 선택하세요.';
        }
        if(err) {
          this.toast(err);
          return false;
        }
        else return true;
      },
      // 초기화 작업
      initialize() {
        // 배송조건id 순으로 SORTING
        this.value.order_product = this.value.order_product.sort(function(a,b) {
          return a['delivery_price']['id'] - b['delivery_price']['id']
        })

        this.value.order_product.forEach(item=> {
          item.rowspan = 0;
        })
        for(let i=0; i<this.value.order_product.length; i++) {
          this.value.order_product[i].rowspan = 1;
          //console.log(i, 1)
          // 배송비 부과방법(0: 배송비조건별, 1: 상품별)
          if(this.value.order_product[i].delivery_price.tax_method===1) {
            this.value.order_product[i].rowspan = 1;
            continue;
          }
          let j = 0;
          for(j=i+1; j<this.value.order_product.length; j++) {
            // 배송조건 번호가 같을 경우
            if(this.value.order_product[i].delivery_price.id === this.value.order_product[j].delivery_price.id) {
              this.value.order_product[i].rowspan += 1;
            }
            // 배송조건 번호가 다를 경우
            else {
              break;
            }
          }
          i = j-1;
        }
        this.calcTotal();
      },
      // 합계 계산
      calcTotal() {
        let total_comm_price = 0;
        let total_point = 0;
        let total_discount_price = 0;
        let total_product_price = 0;
        let total_delivery_price = 0;
        for(let i=0; i<this.value.order_product.length; i++) {
          total_comm_price += this.value.order_product[i].comm_price * this.value.order_product[i].quantity;
          total_point += this.value.order_product[i].point * this.value.order_product[i].quantity;
          total_discount_price += this.value.order_product[i].discount_price * this.value.order_product[i].quantity;
          total_product_price += this.value.order_product[i].total_price * this.value.order_product[i].quantity;

          if(this.value.order_product[i].rowspan>0) {
            total_delivery_price += this.calcDeliveryPrice(this.value.order_product[i], i);
          }
        }
        this.value.order.comm_price = total_comm_price;
        this.value.order.point = total_point;
        this.value.order.discount_price = total_discount_price
        this.value.order.product_price = total_product_price;
        this.value.order.delivery_price = total_delivery_price;

        this.value.order.total_price = this.value.order.product_price + this.value.order.delivery_price - this.value.order.discount_price;
      },
      // 배송비 계산
      calcDeliveryPrice(item, index) {
        // item == value.order_product
        let dp = item.delivery_price;
        let rowspan = item.rowspan;
        if(rowspan===0) return;
        // 고정배송비
        if(dp.delivery_type===0) {
          return dp.fix_price;
        }
        // 배송비무료
        if(dp.delivery_type===1) {
          return 0;
        }
        // 금액별
        if(dp.delivery_type===2) {
          return this.calcClassify(item, index, 'total_price');
        }
        // 수량별
        if(dp.delivery_type===3) {
          return this.calcClassify(item, index, 'quantity');
        }
        // 무게별
        if(dp.delivery_type===4) {
          return this.calcClassify(item, index);
        }
      },
      // 분류별 계산
      calcClassify(item, index, attr) {
        if(item.rowspan>0) {
          let dp = item.delivery_price;
          let dp_setting = item.delivery_price.delivery_price_setting;
          let maxlength = index + item.rowspan;
          // 배송비조건별
          if(dp.tax_method===0) {
            let total = 0;
            for(let i=index; i<maxlength; i++) {
              total += parseInt(this.value.order_product[i][attr]);

            }
            for(let j=0; j<dp_setting.length; j++) {
              if(parseInt(dp_setting[j].min) <= total && total < parseInt(dp_setting[j].max)) {
                return parseInt(dp_setting[j].price);
              }
              // 마지막 조건일 경우 예외처리
              else if(j === dp_setting.length-1) {
                if(parseInt(dp_setting[j].min) <= total) return parseInt(dp_setting[j].price);
              }
            }
          }
          // 상품별
          else {
            let total = parseInt(this.value.order_product[index][attr]);
            for(let x=0; x<dp_setting.length; x++) {
              if(parseInt(dp_setting[x].min) <= total && total < parseInt(dp_setting[x].max)) {
                return parseInt(dp_setting[x].price);
              }
              // 마지막 조건일 경우 예외처리
              else if(x === dp_setting.length-1) {
                if(parseInt(dp_setting[x].min) <= total) return parseInt(dp_setting[x].price);
              }
            }
          }
        }
      },
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'

  .product-short-input
    width 89px
</style>
